import React, { PropTypes } from 'react';
import {
  equals,
  cond,
  T,
  call,
  ifElse,
  always,
} from 'ramda';
import SubmitDialog from './existing-company-dialog';

const getErrorMessage = props => call(cond([
  [equals('COMPANY'), () => (
    props.showExistingCompanyDialog ?
      <SubmitDialog
        showExistingCompanyDialog={props.showExistingCompanyDialog}
        dispatchedUpdateProps={props.dispatchedUpdateProps}
        goToConfirmationPage={props.goToConfirmationPage}
        companyName={props.companyName}
        submitSignUpAction={props.submitSignUpAction}
        companyTypeChecked={props.companyTypeChecked}
        selectedCompanyType={props.selectedCompanyType}
        acctCreationReason={props.acctCreationReason}
        country={props.country}
        email={props.email}
        password={props.password}
        oneOrMultiProperties={props.oneOrMultiProperties}
        numOfProperties={props.numOfProperties}
        oneOrMultiCities={props.oneOrMultiCities}
        existingCompanyId={props.existingCompanyId}
        region={props.region}
      /> : <span/>
  )],
  [T, error => (
    <p style={{ textAlign: 'center', color: 'red', fontSize: '14px' }}>
      {call(ifElse(
        equals('EMAIL'),
          always('This email is already taken. Please enter a different email.'),
        always('There was an error creating your account. Please try again.')
      ), error)}
    </p>
  )],
]), props.error);

const SignUpError = props => getErrorMessage(props);

SignUpError.propTypes = {
  history: PropTypes.object,
  error: PropTypes.string,
  goBack: PropTypes.func,
  save: PropTypes.func,
};

export default SignUpError;



// WEBPACK FOOTER //
// ./src/app/components/signup/form/error.jsx